import accessoriesOptions from '@/ui/ui_accessories/default-selectors.json';

/**
 * @module getProductFullAccessoriesData
 *
 * @description
 * Получение данных об аксессуарах из ноды товара
 * @param {HTMLElement} productNode - узел товара
 *
 * @return {Object} - объект с данными об аксессуарах
 */
export default (productNode) => {
  const accessoriesData = {};

  const accessoriesItemNodes = Array.from(productNode.querySelectorAll(`${accessoriesOptions.accessoriesItem.attr}`));

  if (!accessoriesItemNodes.length) { return accessoriesData; }

  for (const accessoriesItemNode of accessoriesItemNodes) {
    const accessoryId = accessoriesItemNode.dataset[accessoriesOptions.accessoriesItemId.data];

    if (!accessoryId) { continue; }

    accessoriesData[accessoryId] = {};

    const accessoriesCheckedValueNodes =
      Array.from(accessoriesItemNode.querySelectorAll(`${accessoriesOptions.accessoryValuesItem.attr} input:checked`));

    if (!accessoriesCheckedValueNodes.length) { continue; }

    for (const accessoryValueNode of accessoriesCheckedValueNodes) {
      accessoriesData[accessoryId][accessoryValueNode.value] = 1;
    }
  }

  return accessoriesData;
};
